// extracted by mini-css-extract-plugin
module.exports = {"sub_title":"partner_say_sub_title__aIpmH","link":"partner_say_link__UZnFF","image_wrapper":"partner_say_image_wrapper__b8pjq"};